<template>
  <div class="footerBox">
    <div class="content">
      <div class="bottomImgInfo">
        <img src="https://htmlqiniu.jihex.com/saas/saas-ui/bottomBannerNewText.png" alt="">
        <div class="btn" @click="skipTo"></div>
      </div>
      <div class="companyTitle">
        <div class="leftText">{{ companyName }} 2019 @ All Rights Reserved</div>
        <div @click="goICP" class="rightText">{{providerText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      providerText:'',
      companyName: ''
    }
  },
  methods:{
    skipTo() {
      window.open('https://agent.timesaas.cn/agent/15?bms=no&source=portal&user_question=我想联系太目销售')
    },
    goICP() {
      window.open('https://beian.miit.gov.cn/')
    }
  },
  mounted () {
    // console.log(window.location)
    //备案号
    if(window.location.host.includes('jiheclub.cn')||window.location.host.includes('jiheclub.com') || window.location.host.includes('jihex.cn')) {
      this.providerText='浙ICP备14041939号-2'
    }else if(window.location.host.includes('jihelife.com')) {
      this.providerText = '浙ICP备14041939号-1'
    }else if(window.location.host.includes('jihex.com')) {
      this.providerText = '浙ICP备20015274号-1'
    }else if(window.location.host.includes('taimu.com.cn')) {
      this.providerText = '浙ICP备20015274号-2'
    }else if(window.location.host.includes('timesaas.cn')) {
      this.providerText = '浙ICP备14041939号-3'
    }else if(window.location.host.includes('timesaas.vip')) {
      this.providerText = '浙ICP备14041939号-4'
    }else if (window.location.host.includes('tm-yuncang.cn')) {
      this.providerText = '浙ICP备2023032202号-1'
    }
    if (window.location.host.includes('tm-yuncang.cn')) {
      this.companyName = '杭州太目云仓文化旅游有限公司'
    }else {
      this.companyName = '杭州太目科技有限公司'
    }
  }
}
</script>
<style lang="scss" scoped>
.footerBox {
  width: 100%;
  min-width: 1200px;
  height: 240px;
  background: url(https://htmlqiniu.jihex.com/bottomBannerNew.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
  position: relative;
  .content {
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottomImgInfo {
    position: relative;
    img{
      display: block;
      width: 1200px;
      height: 160px;
    }
    .btn{
      width: 66px;
      height: 22px;
      position: absolute;
      top: 63px;
      right: 365px;
      cursor: pointer;
    }
  }
  .companyTitle {
    color: #868B8F;
    line-height: 12px;
    font-size: 12px;
    display: flex;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 40px;
    .leftText {
      border-right: 1px solid #606266;
      padding-right: 10px;
      line-height: 12px;
      margin-right:10px;
    }
  }
}
.rightText {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/navTop/footer.vue